const axios = require('axios');

export default class ApiService {

  constructor(baseURL = null, token = null, sendBearer = true) {
    this.http = axios.create({
      baseURL: baseURL ? baseURL : process.env.COMMUNITY_API
    });
    this.token = token;
    if (!this.token && typeof window.user !== 'undefined') {
      this.token = window.user.community_token;
    }
    this.params = sendBearer ? {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    } : null;
  }

  post(url, data, config = this.params) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.http
        .post(url, data, config)
        .then(response => resolve(response.data))
        .catch(error => reject(('undefined' !== typeof(error.response)) ? error.response : error));
    });
  }

  patch(url, data, config = this.params) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.http
        .patch(url, data, config)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  put(url, data, config = this.params) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.http
        .put(url, data, config)
        .then(response => resolve(response.data))
        .catch(error => reject(('undefined' !== typeof(error.response) && 'undefined' !== typeof(error.response.data)) ? error.response.data : 'undefined' !== typeof(error.response) ? error.response : error));
    });
  }

  get(url, config = this.params) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.http
        .get(url, config)
        .then(response => resolve(response.data))
        .catch(error => reject(('undefined' !== typeof(error.response) && 'undefined' !== typeof(error.response.data)) ? error.response.data : 'undefined' !== typeof(error.response) ? error.response : error));
    });
  }

  delete(url, config = this.params) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.http
        .delete(url, config)
        .then(response => resolve(response.data))
        .catch(error => reject(('undefined' !== typeof(error.response) && 'undefined' !== typeof(error.response.data)) ? error.response.data : 'undefined' !== typeof(error.response) ? error.response : error));
    });
  }

}
